const runtimeConfig = typeof window !== 'undefined' ? window.__POSCRAFT_CONFIG__ || {} : {};

export const ORDERING_CONTEXT_KEY = 'app_menu_ordering_context_v2';

export function readJwtPayload(tokenLike) {
  const raw = String(tokenLike || '')
    .trim()
    .replace(/^Bearer\s+/i, '');
  if (!raw || raw.split('.').length < 2) return null;
  try {
    const seg = raw.split('.')[1];
    const b64 = seg.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '==='.slice((b64.length + 3) % 4);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

export function companyIdFromJwt(tokenLike) {
  const payload = readJwtPayload(tokenLike);
  if (!payload) return null;
  const n = Number(payload.cmp ?? payload.Cmp ?? payload.companyId ?? payload.CompanyId);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function currencyTypeIdFromJwt(tokenLike) {
  const payload = readJwtPayload(tokenLike);
  if (!payload) return null;
  const n = Number(payload.curr ?? payload.Curr ?? payload.currencyTypeId ?? payload.CurrencyTypeId);
  return Number.isFinite(n) && n > 0 ? n : null;
}

const initialCompanyId =
  companyIdFromJwt(runtimeConfig.BEARER_TOKEN) ?? (Number(runtimeConfig.COMPANY_ID) || 0);

const initialLocationId = Number(
  runtimeConfig.DEFAULT_LOCATION_ID ?? runtimeConfig.LOCATION_ID ?? 1
);

let activeCompanyId = Number.isFinite(initialCompanyId) && initialCompanyId > 0 ? initialCompanyId : 1989;
let activeLocationId = Number.isFinite(initialLocationId) && initialLocationId > 0 ? initialLocationId : 1;

export function getPoscraftCompanyId() {
  return activeCompanyId;
}

export function getPoscraftLocationId() {
  return activeLocationId;
}

/** Returns true when company or location id changed (caller should clear cached ordering context). */
export function setPoscraftSiteIds({ companyId, locationId } = {}) {
  const prevCompany = activeCompanyId;
  const prevLocation = activeLocationId;

  if (companyId != null) {
    const n = Number(companyId);
    if (Number.isFinite(n) && n > 0) activeCompanyId = n;
  }
  if (locationId != null) {
    const n = Number(locationId);
    if (Number.isFinite(n) && n > 0) activeLocationId = n;
  }

  return prevCompany !== activeCompanyId || prevLocation !== activeLocationId;
}

export function orderingContextMatchesSite(saved) {
  if (!saved || typeof saved !== 'object') return false;
  if (saved.companyId == null && saved.locationId == null) return false;
  return (
    Number(saved.companyId) === Number(activeCompanyId) &&
    Number(saved.locationId) === Number(activeLocationId)
  );
}
